// extracted by mini-css-extract-plugin
module.exports = {"RoomsTitle":"room_grid_RoomsTitle__22bMk","RoomsSubTtile":"room_grid_RoomsSubTtile__3RcuO","imgContainer":"room_grid_imgContainer__1zSfn"};